<template>
    <div class="sps-home" :class="{ 'is-full-image': fullImage }" :style="homeStyle">
        <ShellHeader variant="home" @close="minimize" />
        <div class="sps-home__body">
            <div v-if="pinned.length" class="sps-home__pinned">
                <component v-for="c in pinned" :is="componentOf(c)" :key="c.key || c.type" :card="c" />
            </div>
            <component v-for="c in rest" :is="componentOf(c)" :key="c.key || c.type" :card="c" @ask="$emit('ask')" @open-article="$emit('open-article', $event)" />
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ShellHeader from "./ShellHeader.vue";
import { CARD_COMPONENTS } from "./cards/index";
import { sendMinimizeAction } from "../../../utils/parentWindowConnection";
import { imageModeOf, imageBackground } from "../../../utils/shell/homeBackground";
export default {
    name: "ShellHomeView",
    components: { ShellHeader },
    computed: {
        ...mapGetters({ cards: "shell/cards", config: "shell/config" }),
        // sabitlenen duyurular siradan bagimsiz en ustte kalir ve kaydirmada gorunur
        pinned() { return this.cards.filter((c) => c.type === "announcement" && c.pinned); },
        rest() { return this.cards.filter((c) => !(c.type === "announcement" && c.pinned)); },
        fullImage() { return imageModeOf(this.config.header) === "full"; },
        homeStyle() { return this.fullImage ? imageBackground(this.config.header, "linear-gradient(180deg, rgba(0,0,0,.4), rgba(0,0,0,.08) 45%, rgba(0,0,0,0))") : {}; },
    },
    methods: { componentOf(c) { return CARD_COMPONENTS[c.type] || null; }, minimize() { sendMinimizeAction(); } },
};
</script>
<style lang="scss">
.sps-home { display: flex; flex-direction: column; height: 100%; background: var(--background-color-first, #f5f6fa);
    &__body { flex: 1; overflow: auto; padding: 0 14px 16px; margin-top: -46px; }
    &__pinned { position: sticky; top: 0; z-index: 2; }
    // gorsel tum sayfayi kapliyor: kartlar ustunde yuzer, baslik bandi ust uste binmez
    &.is-full-image &__body { margin-top: 0; }
    &.is-full-image .sps-shell-header__greeting { padding-bottom: 24px; }
}
.sps-card { display: block; width: 100%; box-sizing: border-box; text-align: left; margin-bottom: 12px; padding: 14px 16px; border: 0; border-radius: var(--sps-radius-md, 14px); background: var(--sps-surface, #fff); color: var(--primary-text, #1f2337); box-shadow: var(--sps-shadow, 0 4px 18px rgba(30, 30, 80, 0.1)); font: inherit; text-decoration: none; cursor: default;
    &--ask, &--link { display: flex; align-items: center; gap: 12px; cursor: pointer; &:hover { box-shadow: 0 6px 22px rgba(30, 30, 80, 0.16); } }
    // vue-material'in genel a rengi bağlantı kartını maviye boyuyordu
    &--link:not(.md-button), &--link:not(.md-button):hover { color: var(--primary-text, #1f2337); text-decoration: none; }
    &__text { flex: 1; min-width: 0; }
    &__title { font-weight: 600; font-size: 14px; }
    &__sub { font-size: 12px; color: var(--sps-muted, rgba(15, 23, 42, 0.65)); margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    &__chevron { opacity: 0.4; font-size: 18px; }
    &__icon img { width: 36px; height: 36px; border-radius: 8px; object-fit: cover; }
    &__search { width: 100%; box-sizing: border-box; margin-top: 10px; padding: 9px 12px; border: 1px solid var(--sps-border, rgba(15, 23, 42, 0.12)); border-radius: 10px; background: var(--sps-surface, #fff); color: inherit; font: inherit; font-size: 13px; &:focus { outline: none; border-color: var(--button-color, #4f46e5); } }
    &__list { list-style: none; margin: 6px 0 0; padding: 0; li + li { border-top: 1px solid var(--sps-border, rgba(15, 23, 42, 0.06)); } button { display: flex; justify-content: space-between; width: 100%; padding: 10px 0; border: 0; background: transparent; color: inherit; font: inherit; font-size: 13px; text-align: left; cursor: pointer; span { opacity: 0.4; } &:hover { color: var(--button-color, #4f46e5); } } }
    &__empty, &__body { font-size: 13px; opacity: 0.7; margin: 8px 0 0; }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/shell/HomeView.vue